(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-matching-selector"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const sections = document.querySelectorAll('[id^="ProductMatching-"]');

      sections.forEach((section) => {
        const selectEl = section.querySelector('[data-product-matching-option]');
        const cta = section.querySelector('[data-product-matching-cta]');
        const ctaText = cta
          ? cta.querySelector('[data-product-matching-button-text]')
          : null;
        const dataWrap = section.querySelector('[data-product-matching-data]');

        if (! selectEl || ! cta || ! ctaText || ! dataWrap) return;
        


        const defaultLabel = ctaText.textContent.trim();

        const blockMap = new Map();
        dataWrap.querySelectorAll('[data-index]').forEach((span) => {
          blockMap.set(span.getAttribute('data-index'), {
            url: span.getAttribute('data-url') || '',
            label: span.getAttribute('data-label') || ''
          });
        });

        selectEl.addEventListener('change', () => {
          const match = blockMap.get(selectEl.value);

          if (match && match.url) {
            cta.setAttribute('href', match.url);
            cta.setAttribute('aria-disabled', 'false');
            ctaText.textContent = match.label || defaultLabel;
          } else {
            cta.setAttribute('href', '#');
            cta.setAttribute('aria-disabled', 'true');
            ctaText.textContent = defaultLabel;
          } cta.classList.remove('is-updated');
          void cta.offsetWidth;
          cta.classList.add('is-updated');
          cta.addEventListener('animationend', () => cta.classList.remove('is-updated'), {once: true});
        });
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
